module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-med.0b5b1209.jpg";